import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, RadioGroup, Radio, FormControlLabel,
  Typography, Grid
} from "@mui/material";
import { putData } from "../../BaseUrl";

const CATEGORIES = ["Reading", "Writing", "Speaking", "Listening", "Grammar"];

const EvaluationDialog = ({ open, onClose, application, onSuccess }) => {
  const [result, setResult] = useState("");
  const [marks, setMarks] = useState({});
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleMarkChange = (category) => (e) => {
    const val = e.target.value;
    if (val === "" || (Number(val) >= 0 && Number(val) <= 100)) {
      setMarks(prev => ({ ...prev, [category]: val }));
    }
  };

  const handleSubmit = async () => {
    if (!result) {
      setError("Please select Pass or Fail");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const evaluationMarks = {};
      Object.entries(marks).forEach(([k, v]) => {
        if (v !== "") evaluationMarks[k] = Number(v);
      });

      await putData(`admin/admission/applications/${application.id}/evaluate`, {
        result,
        evaluationMarks: Object.keys(evaluationMarks).length > 0 ? evaluationMarks : undefined,
        evaluationNotes: notes || undefined
      });

      onSuccess(result === "pass" ? "Evaluation marked as passed" : "Evaluation marked as failed");
      resetForm();
    } catch (err) {
      setError(err?.message || "Evaluation failed");
    }
    setLoading(false);
  };

  const resetForm = () => {
    setResult("");
    setMarks({});
    setNotes("");
    setError("");
  };

  return (
    <Dialog open={open} onClose={() => { onClose(); resetForm(); }} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>
        Evaluate: {application?.firstName} {application?.lastName}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Application #{application?.applicationNumber} | Grade: {application?.gradeApplyingFor}
        </Typography>

        <Typography variant="subtitle2" mb={1}>Category Marks (0-100)</Typography>
        <Grid container spacing={1} mb={2}>
          {CATEGORIES.map(cat => (
            <Grid item xs={6} key={cat}>
              <TextField size="small" fullWidth label={cat} type="number"
                value={marks[cat] || ""} onChange={handleMarkChange(cat)}
                inputProps={{ min: 0, max: 100 }} />
            </Grid>
          ))}
        </Grid>

        <TextField size="small" fullWidth multiline rows={3} label="Evaluation Notes"
          value={notes} onChange={(e) => setNotes(e.target.value)} sx={{ mb: 2 }} />

        <Typography variant="subtitle2" mb={1}>Result *</Typography>
        <RadioGroup row value={result} onChange={(e) => setResult(e.target.value)}>
          <FormControlLabel value="pass" control={<Radio color="success" />} label="Pass" />
          <FormControlLabel value="fail" control={<Radio color="error" />} label="Fail" />
        </RadioGroup>

        {error && <Typography color="error" variant="body2" mt={1}>{error}</Typography>}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => { onClose(); resetForm(); }} variant="outlined" color="inherit">Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}
          sx={{ background: "linear-gradient(90deg, #4A7BA8, #244C77)" }}>
          {loading ? "Submitting..." : "Submit Evaluation"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EvaluationDialog;
